<template>
	<div>
		<common-header><div class="header-title text-left">收银台</div></common-header>
		<div class="pay-container text-left">
			<div class="tip">
				<span>订单提交成功，请尽快付款！</span>
				<span>
					订单编号：
					<span>{{ order_no }}</span>
				</span>
			</div>
			<div class="tip">
				<span>
					<span class="color-red">{{ remain.remain_time_tip }}</span>
				</span>
				<span class="color-gray">超时订单将会被取消</span>
			</div>
			<div class="pay-type">
				<p class="title">
					<img src="../../assets/pay/wxPay.png" style="width: 40px;height: 40px;vertical-align: middle;" />
					欢迎使用微信支付
					<span class="tip color-red">因需要微信公众号，当前只为演示</span>
				</p>
				<div class="flex" style="justify-content: space-around;">
					<div class="scan-code">
						<div class="qrcode" ref="qrCodeUrl">
							<div class="mask" v-if="!remain.remain_time">
								<span>二维码已失效</span>
							</div>
						</div>
						<div class="saoma-tip flex">
							<i class="iconfont icon-saoma"></i>
							<span>请使用微信扫一扫<br/>扫描二维码支付</span>
						</div>
					</div>
					<div><img src="../../assets/pay/pc_icon_phone-bg.png" /></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import QRCode from 'qrcodejs2';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			order_no: '',
			order: {},
			remain: {
				remain_time: '',
				remain_time_tip: ''
			},
			creatQrCode() {
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: 'xxxx', // 需要转换为二维码的内容
					width: 200,
					height: 200,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				});
			}
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.order = JSON.parse(localStorage.getItem('orderpay_' + this.userInfo.id));
		this.order_no = this.order.order_no;
		this.remainTimeOne(this.order);
		this.creatQrCode();
	},
	methods: {
		// 待付款订单倒计时
		remainTimeOne(order) {
			this.timer = setInterval(() => {
				let thistime = Math.floor(new Date().getTime() / 1000); //当前秒数
				let fukuan_time = order.ctime + 1800; //下单时间+半小时的秒数
				let remain_time = fukuan_time - thistime; //获取剩余秒数
				if (remain_time > 0) {
					this.remain.remain_time = remain_time;
					//console.log(orderList[i].remain_time);
					this.remain.remain_time_tip = '付款时间剩余：' + Math.floor(remain_time / 60) + '分' + (remain_time % 60) + '秒';
				} else {
					this.remain.remain_time = 0;
					this.remain.remain_time_tip = '订单超时已取消';
				}
			}, 1000);
		},
		choosePayType() {
			this.$router.push({ path: '/order/' + this.payType });
		}
	}
};
</script>
<style lang="scss">
.header-title {
	flex: 1;
	font-size: 30px;
	font-weight: bold;
	padding: 0 30px;
	line-height: 80px;
}
.pay-container {
	padding: 20px;
	.tip {
		line-height: 35px;
		span:not(:first-child) {
			margin-left: 10px;
		}
		.color-gray {
			color: gray;
		}
	}
	.pay-type {
		border: 1px solid #f3f3f3;
		padding: 15px 0;
		.title {
			font-size: 19px;
			font-weight: 600;
			line-height: 40px;
			text-align: center;
		}
		.scan-code{
			padding-top: 30px;
			.qrcode {
				display: inline-block;
				position: relative;
				img {
					background-color: #fff; //设置白色背景色
					padding: 6px; // 利用padding的特性，挤出白边
					box-sizing: border-box;
				}
				.mask{
					background: rgba($color: #000000, $alpha: 0.5);
					color: #fff;
					position: absolute;
					width: 100%;
					height: 100%;
					span{
						position: absolute;
						display: block;
						text-align: center;
						width: 100%;
						top:46%;
						left: 0;
					}
				}
			}
			.saoma-tip{
				width: 100%;
				margin-top: 60px;
				padding: 10px;
				justify-content: space-around;
				background-color: $base-color;
				color: #fff;
				text-align: center;
				.icon-saoma{
					font-size: 35px;
					margin-right: 5px;
					vertical-align: baseline;
				}
			}
		}
	}
}
</style>
